<template>
  <b-modal
    hide-footer
    size="xl"
    title="Add Sport Pricekinetic"
    centered
    id="sport-pricekinetic"
    @hide="handleClose"
  >
    <div class="container-sport text-black">
      <b-row>
        <b-col cols="12" class="mb-2">
          <!-- HEADER CREATE SPORT -->
          <div class="d-flex justify-content-end align-items-center">
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              variant="success"
              @click="handleSubmit"
              :disabled="loadingCreateSport"
            >
              <feather-icon icon="PlusIcon" /><Spinner
                v-if="loadingCreateSport"
              />
              <template v-else> Create Sport </template>
            </b-button>
          </div>
        </b-col>

        <!-- Sport Management -->
        <b-col cols="12">
          <b-card no-body class="mb-2">
            <b-card-header class="bg-dark text-white p-1">
              🏈 Sport Management
            </b-card-header>
            <b-card-body>
              <h5 class="mt-3 mb-1 text-body font-weight-bold">
                Create Sport Category
              </h5>

              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Icon:</span>
                      <b-form-select
                        v-model="form.icon"
                        :options="iconOptions"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Display Order:</span>
                      <b-form-input
                        v-model="form.order"
                        :formatter="formatPrice"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-form-group>
                  <label class="font-weight-bold">Sport Code:</label>
                  <b-form-input
                    v-model="form.code"
                    placeholder="Eg. american_football"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="font-weight-bold text-warning"
                    >Sport Name:</label
                  >
                  <b-form-input
                    v-model="form.name"
                    placeholder="Eg. American Football"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Short Name:</span>
                  <b-form-input
                    v-model="form.shortName"
                    placeholder="Short version"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Default Name:</span>
                  <b-form-input
                    v-model="form.defaultName"
                    placeholder="Official sport name"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Description:</span>
                  <b-form-textarea
                    v-model="form.description"
                    placeholder="Sport description and additional details"
                  ></b-form-textarea>
                </b-form-group>

                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Display:</span>
                      <b-form-radio-group
                        v-model="form.display"
                        :options="yesNoOptions"
                        name="display-options"
                        class="mt-1"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Featured Sport:</span>
                      <b-form-radio-group
                        v-model="form.featured"
                        :options="yesNoOptions"
                        name="featured-options"
                        class="mt-1"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Sport Category:</span>
                      <b-form-select
                        v-model="form.category"
                        :options="categoryOptions"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Primary Region:</span>
                      <b-form-select
                        v-model="form.region"
                        :options="regionOptions"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Betting Configuration -->
        <b-col cols="12">
          <b-card no-body>
            <b-card-header
              class="text-white p-1"
              style="background-color: #0d6efd"
            >
              Betting Configuration
            </b-card-header>
            <b-card-body>
              <b-row class="mt-2">
                <b-col md="6">
                  <div class="font-weight-bolder">Default Bet Types:</div>
                  <b-row>
                    <b-col
                      v-for="(option, index) in defaultBetTypes"
                      :key="'bet-' + index"
                      md="12"
                      class="mt-1"
                    >
                      <b-form-checkbox
                        v-model="formMarket.defaultBetTypes"
                        :value="option.value"
                      >
                        <span class="font-weight-bold">{{ option.text }}</span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col md="6">
                  <div class="font-weight-bolder">Market Types:</div>
                  <b-row>
                    <b-col
                      v-for="(option, index) in marketTypes"
                      :key="'market-' + index"
                      md="12"
                      class="mt-1"
                    >
                      <b-form-checkbox
                        v-model="formMarket.marketTypes"
                        :value="option.value"
                      >
                        <span class="font-weight-bold"> {{ option.text }}</span>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="mt-2 mb-1">
                <b-col md="4">
                  <b-form-checkbox v-model="formMarket.allowLiveBetting">
                    <span class="font-weight-bold"> Allow Live Betting</span>
                  </b-form-checkbox>
                </b-col>
                <b-col md="4">
                  <b-form-checkbox v-model="formMarket.allowCashOut">
                    <span class="font-weight-bold"> Allow Cash Out</span>
                  </b-form-checkbox>
                </b-col>
                <b-col md="4">
                  <b-form-checkbox v-model="formMarket.allowLiveStreaming">
                    <span class="font-weight-bold">Live Streaming</span>
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Commission Rate (%):</span>
                    <b-form-input
                      v-model="formMarket.commissionRate"
                      :formatter="formatPrice"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Default Odds Format:</span>
                    <b-form-select
                      v-model="formMarket.oddsFormat"
                      :options="oddsFormatOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12">
          <div class="d-flex justify-content-end">
            <b-button variant="secondary" class="mr-1" @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              @click="handleSubmit"
              variant="success"
              :disabled="loadingCreateSport"
            >
              <Spinner v-if="loadingCreateSport" />
              <template v-else> Create Sport </template>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import {
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
  BBadge,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    flatPickr,
    Spinner,
    BCardText,
    BBadge,
  },
  data() {
    return {
      form: {
        icon: "",
        order: null,
        code: "",
        name: "",
        shortName: "",
        defaultName: "",
        description: "",
        display: false,
        featured: false,
        category: "",
        region: "",
      },
      startDate: "",
      endDate: "",
      yesNoOptions: [
        { value: false, text: "No" },
        { value: true, text: "Yes" },
      ],
      iconOptions: [
        { value: "🏈", text: "🏈 Australian Rules" },
        { value: "🏉", text: "🏉 Rugby League" },
        { value: "🏀", text: "🏀 Basketball" },
        { value: "⚽", text: "⚽ Football" },
        { value: "🏏", text: "🏏 Cricket" },
        { value: "🏒", text: "🏒 Ice Hockey" },
        { value: "⚾", text: "⚾ Baseball" },
        { value: "🥊", text: "🥊 Boxing/MMA" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      categoryOptions: [
        { value: "Team Sports", text: "Team Sports" },
        { value: "Individual Sports", text: "Individual Sports" },
        { value: "Racing Sports", text: "Racing Sports" },
        { value: "Combat Sports", text: "Combat Sports" },
        { value: "Motorsport", text: "Motorsport" },
      ],
      regionOptions: [
        { value: "Global", text: "Global" },
        { value: "Australia", text: "Australia" },
        { value: "North America", text: "North America" },
        { value: "Europe", text: "Europe" },
        { value: "Asia", text: "Asia" },
      ],
      formMarket: {
        defaultBetTypes: [],
        marketTypes: [],
        commissionRate: "",
        oddsFormat: "",
        allowCashOut: false,
        allowLiveBetting: false,
        allowLiveStreaming: false,
      },
      defaultBetTypes: [
        { value: "Match Result", text: "Match Result" },
        { value: "handicap", text: "Handicap" },
        { value: "overUnder", text: "Over/Under" },
        { value: "outrightWinner", text: "Outright Winner" },
        { value: "bothTeamsScore", text: "Both Teams to Score" },
        { value: "correctScore", text: "Correct Score" },
      ],
      marketTypes: [
        { value: "preMatch", text: "Pre-Match" },
        { value: "live", text: "Live" },
        { value: "specials", text: "Specials" },
        { value: "outrights", text: "Outrights" },
        { value: "props", text: "Props" },
        { value: "futures", text: "Futures" },
      ],
      oddsFormatOptions: [
        { value: "Decimal", text: "Decimal" },
        { value: "Fractional", text: "Fractional" },
        { value: "American", text: "American" },
      ],
    };
  },
  async created() {},
  watch: {},
  computed: {
    ...mapState("sport/create", ["loadingCreateSport", "loadingDeleteSport"]),
    isSubmitting() {
      return this.loadingDeleteSport;
    },
  },
  methods: {
    ...mapActions({
      createSport: "sport/create/createSport",
      getListSport: "sport/list/getListSport",
      deleteSport: "sport/create/deleteSport",
      getListLeagueOfSport: "sport/list/getListLeagueOfSport",
      deleteLeague: "sport/create/deleteLeague",
    }),
    handleBack() {
      this.$bvModal.hide("sport-pricekinetic");
    },
    async handleSubmit() {
      const res = await this.createSport({
        name: this.form.name,
        shortName: this.form.shortName,
        defaultName: this.form.defaultName,
        description: this.form.description,
        code: this.form.code,
        icon: this.form.icon,
        orderNumber: this.form.order ? Number(this.form.order) : null,
        source: "pricekinetic",
        status: this.form.display ? "active" : "disabled",
        isFeatured: this.form.featured ? 1 : 0,
        category: this.form.category,
        region: this.form.region,
        advanceData: {
          commissionRate: Number(this.formMarket.commissionRate),
          oddsFormat: this.formMarket.oddsFormat,
          allowCashOut: this.formMarket.allowCashOut ? 1 : 0,
          allowLiveBetting: this.formMarket.allowLiveBetting ? 1 : 0,
          allowLiveStreaming: this.formMarket.allowLiveStreaming ? 1 : 0,
        },
      });
      if (res) {
        this.$emit("refresh");
        this.showToastSuccess(true, "New sport created successfully!");
        this.handleBack();
      }
    },
    formatPrice(value) {
      value = value.replace(/[^0-9.]/g, "");

      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      if (value.includes(".")) {
        const decimalPart = value.split(".")[1];
        if (decimalPart.length > 2) {
          const integerPart = value.split(".")[0];
          value = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }
      }

      return value;
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.container-sport {
  max-width: 1024px;
  margin: auto;
  padding: 16px;
  padding-top: 0;
}

.show-more {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  color: blue;
}
</style>
